import { tenantApi } from '@shared/api/tenantApi';
import { unwrapList } from '@shared/api/unwrap';

/**
 * Member join-request approval (admin) — mirrors the tenant portal's
 * member-requests module. Endpoints:
 *   - GET  /member-requests              list (perm members:requests:read)
 *   - POST /member-requests/:id/approve  approve (perm members:requests:approve)
 *   - POST /member-requests/:id/reject   reject  (perm members:requests:approve)
 */

export interface MemberRequest {
  member_request_id: string;
  requester_display?: string;
  email?: string | null;
  status: string;
  created_at: string;
  invite_expires_at?: string | null;
  /** Submitted join details (first_name, last_name, phone, member_type, …). */
  member_data?: Record<string, unknown> | null;
}

function mapRow(row: unknown): MemberRequest {
  const r = (row ?? {}) as Record<string, unknown>;
  return {
    member_request_id: String(r.member_request_id ?? r.id ?? ''),
    requester_display: (r.requester_display as string) ?? undefined,
    email: (r.email as string | null) ?? null,
    status: String(r.status ?? 'pending'),
    created_at: String(r.created_at ?? ''),
    invite_expires_at: (r.invite_expires_at as string | null) ?? null,
    member_data: (r.member_data ?? r.member_data_json ?? null) as Record<string, unknown> | null,
  };
}

export async function fetchMemberRequests(status = 'pending'): Promise<MemberRequest[]> {
  const { data } = await tenantApi.get('/member-requests', { params: { status } });
  // Filter client-side too — the list endpoint may ignore the status param.
  return unwrapList<unknown>(data)
    .map(mapRow)
    .filter((r) => !status || r.status === status);
}

export async function approveMemberRequest(id: string): Promise<void> {
  await tenantApi.post(`/member-requests/${id}/approve`, {});
}

export async function rejectMemberRequest(id: string): Promise<void> {
  await tenantApi.post(`/member-requests/${id}/reject`, {});
}
